const importExportActionTypes = {
    SELECTED_SITE: "SELECTED_SITE",
    GO_TO_WIZARD_STEP: "GO_TO_WIZARD_STEP",
    RETRIEVED_PORTALS: "RETRIEVED_PORTALS",
    RETRIEVED_JOBS: "RETRIEVED_JOBS",
    RETRIEVED_JOB_DETAILS: "RETRIEVED_JOB_DETAILS",
    SUBMITTED_EXPORT_REQUEST: "SUBMITTED_EXPORT_REQUEST",
    RETRIEVED_IMPORT_PACKAGES: "RETRIEVED_IMPORT_PACKAGES",
    GO_TO_IMPORT_WIZARD_STEP: "GO_TO_IMPORT_WIZARD_STEP",
    VERIFIED_IMPORT_PACKAGE: "VERIFIED_IMPORT_PACKAGE",
    SELECTED_PACKAGE: "SELECTED_PACKAGE",
    SUBMITTED_IMPORT_REQUEST: "SUBMITTED_IMPORT_REQUEST",
    CANCELLED_JOB: "CANCELLED_JOB",
    REMOVED_JOB: "REMOVED_JOB",
    VERIFIED_PACKAGE: "VERIFIED_PACKAGE",
    RETRIEVED_LAST_EXPORT_DATE: "RETRIEVED_LAST_EXPORT_DATE",
    SELECTED_JOB: "SELECTED_JOB",
    GET_INITIAL_PORTAL_TABS: "GET_INITIAL_PORTAL_TABS",
    GET_DESCENDANT_PORTAL_TABS: "GET_DESCENDANT_PORTAL_TABS"
};
export default importExportActionTypes;